import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'

import {OpenMenuItem} from './collapsed-menu-items/open-menu-item'
import {ProfileCollapsedMenuItem} from './collapsed-menu-items/profile-menu-item'
import {MyTasksMenuItem} from './menu-items/my-tasks-menu-item'
import {OthersTasksMenuItem} from './menu-items/others-tasks-menu-item'
import {ProjectsMenuItem} from './collapsed-menu-items/projects-menu-item'
import {ChatMenuItem} from './collapsed-menu-items/chat-menu-item'

import {EventFeedMenuItem} from './menu-items/event-feed-menu-item'
import {StatisticsMenuItem} from './menu-items/statistics-menu-item'
import {BillingMenuItem} from './menu-items/billing-menu-item'
import {PartnerMenuItem} from './menu-items/partner-menu-item'
import {FeedbackMenuItem} from './menu-items/feedback-menu-item'

import {CompanyListMenuItem} from './collapsed-menu-items/company-list-menu-item'

export const TwContainerCollapsed = tw.div`
  pt-8
  pb-8
  px-8
  h-full
  flex
  flex-col
`

export const CollapsedMenu = observer(() => {
  return (
    <TwContainerCollapsed>
      <OpenMenuItem />
      <ProfileCollapsedMenuItem />

      <MyTasksMenuItem />
      <OthersTasksMenuItem />
      <ProjectsMenuItem />
      <ChatMenuItem />

      <EventFeedMenuItem />
      <StatisticsMenuItem />
      <BillingMenuItem />
      <PartnerMenuItem />
      <FeedbackMenuItem />

      <CompanyListMenuItem />
    </TwContainerCollapsed>
  )
})
